import { pgTable, text, jsonb, integer, timestamp } from "drizzle-orm/pg-core";
import type { CampaignImageJournal } from "./campaign-gpt-image";
export type NanoBananaJournal = CampaignImageJournal & { legacyBillingOwned?: boolean };

// Narrow recovery owner for Nano callers that do not have a provider journal.
export const nanoBananaReceipts = pgTable("nano_banana_receipts", {
  ownerKey: text("owner_key").primaryKey(),
  journal: jsonb("journal").$type<NanoBananaJournal>().notNull(),
  revision: integer("revision").notNull().default(1),
  updatedAt: timestamp("updated_at").notNull().defaultNow(),
});
